import { motion } from 'framer-motion';
import React from 'react';

interface ScrollManagerProps {
  messagesEndRef: React.RefObject<HTMLDivElement>;
  onViewportEnter: () => void;
  onViewportLeave: () => void;
  children: React.ReactNode;
}

export const ScrollManager: React.FC<ScrollManagerProps> = ({
  messagesEndRef,
  onViewportEnter,
  onViewportLeave,
  children,
}) => {
  return (
    <>
      {children}
      {/* Scroll anchor with framer-motion */}
      <motion.div
        ref={messagesEndRef}
        className="bitte-shrink-0 bitte-min-w-[24px] bitte-min-h-[24px]"
        onViewportEnter={onViewportEnter}
        onViewportLeave={onViewportLeave}
      />
    </>
  );
};
